module.exports = __webpack_public_path__ + "media/images/athletes/3594-f0b4ba7028162ea385bccf3073233295.png";